// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"47af0ea2","213":"ce949969","453":"a407356c"}[chunkId] + ".chunk.js";
};